import { useMemo, useContext } from 'react';
import ThemeContext from '../../../contexts/themeContext';
import AuthContext from '../../../contexts/authContext';
import Aside, { AsideBody, AsideFoot, AsideHead } from '../../../layout/Aside/Aside';
import Brand from '../../../layout/Brand/Brand';
import Navigation from '../../../layout/Navigation/Navigation';
import User from '../../../layout/User/User';
import { dashboardPagesMenu } from '../../../menu';
import { IUserAdmins } from '../../../types/user-type';

function hasPermission(userData: Partial<IUserAdmins> | undefined, slug: string): boolean {
	if (!userData) return false;
	const roles = userData.roles ?? [];
	const perms = userData.permissions ?? [];
	if (roles.some((r) => r.slug === 'admin')) return true;
	return perms.some((p) => p.slug === slug);
}

const DefaultAside = () => {
	const { asideStatus, setAsideStatus } = useContext(ThemeContext);
	const { userData } = useContext(AuthContext);

	const menuDashboardOnly = useMemo(() => {
		const base = {
			dashboard: dashboardPagesMenu.dashboard,
			dashboardPastas: dashboardPagesMenu.dashboardPastas,
		};
		const configSubMenu = dashboardPagesMenu.config.subMenu;
		if (!configSubMenu) return { ...base, config: dashboardPagesMenu.config };
		const subMenuEntries = Object.entries(configSubMenu).filter(([key]) => {
			const permissionByKey: Record<string, string> = {
				usuarios: 'config_usuarios',
				competenciaInterna: 'config_competencia',
				faseProcesso: 'config_fase_processo',
				varas: 'config_varas',
			};
			const slug = permissionByKey[key];
			return slug ? hasPermission(userData, slug) : true;
		});
		const subMenu = subMenuEntries.length
			? Object.fromEntries(subMenuEntries)
			: null;
		const config =
			subMenu === null
				? null
				: { ...dashboardPagesMenu.config, subMenu };
		return {
			...base,
			...(config ? { config } : {}),
		};
	}, [userData]);

	return (
		<Aside>
			<AsideHead>
				<Brand asideStatus={asideStatus} setAsideStatus={setAsideStatus} />
			</AsideHead>
			<AsideBody>
				<Navigation menu={menuDashboardOnly} id='aside-dashboard' />
			</AsideBody>
			<AsideFoot>
				<nav aria-label='aside-bottom-menu' />
				<User />
			</AsideFoot>
		</Aside>
	);
};

export default DefaultAside;
